import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../views/Layout.vue";
import ChatLayout from "../views/ChatLayout_test.vue";
import ListchatLayout from "../views/ListchatLayout.vue";
import HomepageLayout from "../views/HomepageLayout_test.vue";
import AddFriend from "../views/AddFriend.vue";
import CreateGroup from "../views/CreateGroup.vue";
import ProfileUser from "../views/ProfileUser.vue";
import ProfileFriend from "../views/ProfileFriend.vue";
import ProfileGroup from "../views/ProfileGroup.vue";
import AuthenLogin from "../views/AuthenLogin.vue";
import EditPhone from "../views/EditPhone.vue";
import ChatRoomMenu from "../views/ChatRoomMenu.vue";
import ConsentBot from "../views/consent/ConsentBot.vue";
import Setting from "../views/Setting.vue";
import ManageFriendMo from "../views/ManageFriend.vue";
import AnonymousoneMo from "@/components/ManageSetting/Anonymousone.vue"
import FeedbackeMo from "@/components/ManageSetting/Feedback.vue"
import SupportMo from "@/components/ManageSetting/Support.vue"
import policy from "@/components/ManageSetting/Policy.vue";
import TermsofserviceMo from "@/components/ManageSetting/TermsOfService.vue";
import LanguagesMo from "@/components/ManageSetting/Languages.vue";
import QrCodeMo from "@/components/ManageSetting/Qrcode.vue";
import AllProjectMo from "@/components/ManageSetting/ProjectAll.vue";
import AllCalendarMo from "@/components/ManageSetting/CalendarAll.vue"
import CreatedProjectMo from "@/components/ManageSetting/CreatedTask.vue"
import HomepageTaskMo from "@/components/ManageSetting/ProjectTaskId.vue"
import TaskChatRoomMo from "@/components/ManageSetting/TaskChatRoom.vue"
import ProjectChatRoomMo from "@/components/ManageSetting/ChatRoomProject.vue"
// web
import LayoutWeb from "../views/Web/Layout.vue";
import HomepageWeb from "../views/Web/Homepage.vue";
import ChatLayoutWeb from "../views/Web/ChatTest.vue";
import EditProfileWeb from "../views/Web/Setting/EditProfile.vue";
import ManageFriendWeb from "../views/Web/Setting/ManageFriend.vue";
// import EditphoneWeb from "../views/Web/Setting/EditPhone.vue";
import QrcodeWeb from "../views/Web/Manage/Qrcode.vue";
import ProfileFriendWeb from "../views/Web/Manage/ProfileFriend.vue";
import AddFriendWeb from "../views/Web/Manage/AddFriend.vue";
import CreatGroupWeb from "../views/Web/Manage/CreateGroup.vue";
import ProfileGroupWeb from "../views/Web/Manage/ProfileGroup.vue";
import ListMenuMoreWeb from "../views/Web/Manage/ListMenuMore.vue";
import FeedbackWeb from "../views/Web/Manage/Feedback.vue";
import SupportWeb from "../views/Web/Manage/Support.vue";
import PolicyWeb from "../views/Web/Manage/Policy.vue";
import TermsWeb from "../views/Web/Manage/TermsOfService.vue";
import AnonymouseWeb from "../views/Web/Manage/Anonymousone.vue";
import HomepageAllProjectWeb from "../views/Web/Manage/task/homepage_all_project_mo.vue";
import CreateTaskProjectWeb from "../views/Web/Manage/task/create_project_page_mo.vue";
import HomepageTaskWeb from "../views/Web/Manage/task/homepage_task_mo.vue";
import HomepageCalendarWeb from "../views/Web/Manage/task/homepage_calendar_mo.vue";
import LanguagesWeb from "@/views/Web/Setting/Languages.vue";
import ChatRoomMenuWeb from "../views//Web/ChatRoomMenu.vue";
import ConsentBotWeb from "../views/Web/ConsentBot.vue";
import ProjectChatRoom from "../views/Web/Manage/task/homepage_project_mo.vue"
import TaskChatRoom from "../views/Web/Manage/task/task_chat_room.vue"
// page error login
import PageGotoLogin from "../views/PageGotoLogin.vue"
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Layout,
    children: [
      { path: '/homepage', name: 'homepage', component: HomepageLayout },
      { path: '/listchat', name: 'lischat', component: ListchatLayout },
      { path: '/chat/:tokenroom', name: 'chat', component: ChatLayout },
      { path: '/chat/menu/:tokenroom/:type', name: 'chatroommenu', component: ChatRoomMenu }
    ]
  },
  {
    path: "/web",
    name: "layoutweb",
    component: LayoutWeb,
    children: [
      { path: '/web/homepage', name: 'homepage', component: HomepageWeb },
      { path: '/chat-web/:tokenroom', name: 'chat-web', component: ChatLayoutWeb },
      { path: '/chat-web/menu/:tokenroom/:type', name: 'chatroommenuweb', component: ChatRoomMenuWeb },
      { path: '/chat-web/project/:tokenroom/:type', name: 'projectchatroom', component: ProjectChatRoom },
      { path: '/chat-web/task/:projectid/:roomid/:type', name: 'tastchatroom', component: TaskChatRoom },
      { path: '/web/profile', name: 'edit-profile', component: EditProfileWeb },
      { path: '/web/friend', name: 'friend', component: ManageFriendWeb },
      // { path: '/web/editphone', name: 'editphone', component: EditphoneWeb },
      { path: '/web/qrcode', name: 'qrcode', component: QrcodeWeb },
      { path: '/web/profilefriend/:tokenuser', name: 'profilefriend', component: ProfileFriendWeb },
      { path: '/web/addfriend', name: 'addfriend', component: AddFriendWeb },
      { path: '/web/creategroup', name: 'creategroup', component: CreatGroupWeb },
      { path: '/web/profilegroup/:groupid', name: 'profilegroup', component: ProfileGroupWeb },
      { path: '/web/listmenu', name: 'listmenumore', component: ListMenuMoreWeb },
      { path: '/web/feedback', name: 'feedback', component: FeedbackWeb },
      { path: '/web/support', name: 'support', component: SupportWeb }, 
      { path: '/web/policy', name: 'policy', component: PolicyWeb },
      { path: '/web/termsofservice', name: 'terms', component: TermsWeb },
      { path: '/web/anonymousone', name: 'anonymouse', component: AnonymouseWeb },
      { path: '/web/task/homepage', name: 'homepagetask', component: HomepageAllProjectWeb },
      { path: '/web/task/createproject', name: 'createtaskproject', component: CreateTaskProjectWeb },
      { path: '/web/task/:projectid/:roomid', name: 'homepagetask', component: HomepageTaskWeb },
      { path: '/web/task/calendar', name: 'homepagecalendar', component: HomepageCalendarWeb },
      { path: '/web/languages', name: 'langweb', component: LanguagesWeb },
      { path: '/web/check-consent/:tokenroom', name: 'consentbotweb', component: ConsentBotWeb },
      { path: '*', redirect: '/web' }
    ]
  },
  { path: '/addfriend', name: 'addfriend', component: AddFriend },
  { path: '/creategroup', name: 'creategroup', component: CreateGroup },
  { path: '/profile', name: 'profileuser', component: ProfileUser },
  { path: '/profile/editphone', name: 'editphone', component: EditPhone },
  { path: '/profile/friend/:tokenuser', name: 'profilefriend', component: ProfileFriend },
  { path: '/profile/group/:groupid', name: 'profilegroup', component: ProfileGroup },
  { path: '/authen', name: 'authen', component: AuthenLogin },
  { path: '/policy', name: 'policy', component: policy },
  { path: '/setting', name: 'setting', component: Setting },
  { path: '/friend', name: 'managefriend', component: ManageFriendMo },
  { path: '/check-consent/:tokenroom', component: ConsentBot },
  { path: '/anonymousone', name: 'AnonymousoneMo', component: AnonymousoneMo },
  { path: '/feedback', name: 'FeedbackeMo', component: FeedbackeMo },
  { path: '/support', name: 'SupportMo', component: SupportMo },
  { path: '/termsofservice', name: 'termsofservicemo', component: TermsofserviceMo },
  { path: '/languages', name: 'languagesmo', component: LanguagesMo },
  { path: '/qrcode', name: 'qrcodemo', component: QrCodeMo },
  { path: '/task/homepage', name: "allprojectmo", component: AllProjectMo },
  { path: '/task/createproject', name: "createproject", component: CreatedProjectMo },
  { path: '/task/:projectid/:roomid', name: 'homepagetaskmo', component: HomepageTaskMo },
  { path: '/task/:projectid/:roomid/:type', name: 'tastchatroommo', component: TaskChatRoomMo },
  { path: '/project/:tokenroom/:type', name: 'projectchatroommo', component: ProjectChatRoomMo },
  { path: '/calendar', name: "allcalendarmo", component: AllCalendarMo },
  { path: '/goto-login-page', name: "gotologinpage", component: PageGotoLogin },
  { path: '*', redirect: '/' }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_PATH,
  routes,
});

router.beforeEach((to, from, next) => {
  // console.log("route ->", to);
  if (to.matched.length === 0) {
    // หากไม่มีเส้นทางที่ตรง ให้ไปหน้า 404
    next('/404');
  } else {
    next();
  }
});
export default router;
